import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SITE } from '../data/site';
import { useTheme } from '../utils/useTheme';
import { Logo } from './Header';
import { Icon } from './Icon';
import './Footer.css';

const LINKS = [
    { to: '/terms', label: 'Terms' },
    { to: '/privacy', label: 'Privacy' },
    { to: '/payment-rules', label: 'Payment rules' },
    { to: '/2257', label: '2257' },
    { to: '/contact', label: 'Contact' },
    { to: '/report', label: 'Report content' },
];

export function Footer() {
    const { theme, toggle } = useTheme();
    // Phones only: links and the legal block stay folded behind "Info & legal" (always open on desktop).
    const [open, setOpen] = useState(false);
    const bodyRef = useRef(null);
    const { pathname } = useLocation();

    useEffect(() => { setOpen(false); }, [pathname]);

    const toggleOpen = () => {
        setOpen((o) => !o);
        if (!open) setTimeout(() => bodyRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 60);
    };

    return (
        <footer className="ftr container">
            <div className="ftrPanel glass">
                <div className="ftrTop">
                    <div className="ftrBrand">
                        <Logo />
                        <span className="ftrTag">{SITE.tagline} · {SITE.year}</span>
                    </div>
                    <div className="ftrMobileBar">
                        <button type="button" className="btn btn--glass btn--sm" onClick={toggle}>
                            <Icon name={theme === 'dark' ? 'sun' : 'moon'} size={16} />
                            {theme === 'dark' ? 'Light theme' : 'Dark theme'}
                        </button>
                        <button
                            type="button"
                            className={`btn btn--glass btn--sm ftrMore${open ? ' isOpen' : ''}`}
                            onClick={toggleOpen}
                            aria-expanded={open}
                            aria-controls="ftrBody"
                        >
                            Info &amp; legal <Icon name="chevDown" size={16} />
                        </button>
                    </div>
                </div>

                <div id="ftrBody" ref={bodyRef} className={`ftrBody${open ? ' isOpen' : ''}`}>
                    <nav className="ftrLinks" aria-label="Footer">
                        {LINKS.map((l) => <Link key={l.to} to={l.to} className="ftrLink">{l.label}</Link>)}
                        <a className="ftrLink" href={SITE.docs.termsPdf} target="_blank" rel="noopener noreferrer">Terms of Service (PDF)</a>
                        <a className="ftrLink" href={SITE.docs.notice2257Pdf} target="_blank" rel="noopener noreferrer">2257 Exemption (PDF)</a>
                    </nav>
                    <div className="ftrLegal">
                        <p>This website is operated by {SITE.company.name}, {SITE.company.address}.</p>
                        <p>
                            If you have any complaints or concerns, you may contact us at{' '}
                            <a href={`mailto:${SITE.emails.complaints}`}>{SITE.emails.complaints}</a>.
                            Any submission will receive a response and be resolved within a reasonable timeframe,
                            typically within 7 business days.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
